import { render, staticRenderFns } from "./realisasi_keuangan.vue?vue&type=template&id=527fd7bd&"
import script from "./realisasi_keuangan.vue?vue&type=script&lang=js&"
export * from "./realisasi_keuangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports